import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import { LanguageState, Locale } from '../../locales';
import { withCurrentLanguage } from '../../locales';
import getFlagForLocale from '../Flags';

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
  ChangeLocaleButton: {
    textAlign: 'center',
    verticalAlign: 'middle',
    border: '1px solid #555',
  },
}));

export default function ChangeLocaleButton() {
  const classes = useStyles();
  return withCurrentLanguage(
    language => (
      <div style={{ display: 'inline-block' }}>
        <IconButton onClick={() => LanguageState.changeLocale(Locale.PL)}>
          <img
            alt='lang'
            className={classes.ChangeLocaleButton} src={getFlagForLocale(Locale.PL)} />
        </IconButton>
        <IconButton onClick={() => LanguageState.changeLocale(Locale.EN)}>
          <img
            alt='lang'
            className={classes.ChangeLocaleButton} src={getFlagForLocale(Locale.EN)} />
        </IconButton>
        <IconButton onClick={() => LanguageState.changeLocale(Locale.DE)}>
          <img
            alt='lang'
            className={classes.ChangeLocaleButton} src={getFlagForLocale(Locale.DE)} />
        </IconButton>
      </div>
    ));
}
